var map = {
	"./0F611DF460814A5F9FE7A7AE42DF936B.jpg": 96,
	"./94024559CD27455CA7ADE8DA3060F7F7.jpg": 97,
	"./ABAD0937B0704F1482897039EF5F32CB.jpg": 98,
	"./PlaceholderToken.png": 59
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 95;